import { CampaignActionsController } from './campaign-actions.controller'

function campaignActions () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-actions/campaign-actions.html?$$REVISION$$',
    controller: CampaignActionsController
  }
}

export { campaignActions }
